export const isNotEmptyNumericArray = array => {
    return (
        Array.isArray(array) &&
        array.every(element => typeof element === 'number') &&
        array.length > 0
    );
};
